import script from "./ModalCreateTask.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCreateTask.vue?vue&type=script&setup=true&lang=js"

import "./ModalCreateTask.vue?vue&type=style&index=0&id=e87a7184&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e87a7184"]])

export default __exports__